import { useEffect, useState } from 'react';
import JobZImage from '../../../../common/jobz-img';
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../../../config";

const getColorClass = (char) => {
    if (!char) return "bg-default";
    const letter = char.toUpperCase();
    const colors = {
        A: "bg-red", B: "bg-blue", C: "bg-green", D: "bg-orange", E: "bg-purple",
        F: "bg-teal", G: "bg-pink", H: "bg-indigo", I: "bg-yellow", J: "bg-cyan",
        K: "bg-lime", L: "bg-rose", M: "bg-amber", N: "bg-violet", O: "bg-emerald",
        P: "bg-fuchsia", Q: "bg-sky", R: "bg-gray", S: "bg-zinc", T: "bg-stone",
        U: "bg-neutral", V: "bg-blue-500", W: "bg-orange-600", X: "bg-indigo-500",
        Y: "bg-pink-600", Z: "bg-teal-600",
    };
    return colors[letter] || "bg-default";
};

function EmpManageJobsPage() {
    const { t } = useTranslation();
    const [jobs, setJobs] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [dataTable, setDataTable] = useState(null);

    const fetchJobs = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${API_URL}/admin/getAllJob`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            const result = await response.json();
            if (result.status === 200) {
                setJobs(result.data);
            } else {
                setError(result.message || 'Failed to fetch jobs');
            }
        } catch (err) {
            console.error('Error fetching jobs:', err);
            setError('Internal server error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchJobs();
    }, []);

    useEffect(() => {
        if (!loading && jobs.length > 0) {
            const $ = window.$;
            if (!$ || !$.fn.DataTable) return;

            try {
                // Destroy existing DataTable if it exists
                if ($.fn.DataTable.isDataTable('#jobs_bookmark_table')) {
                    $('#jobs_bookmark_table').DataTable().destroy();
                }

                const dt = $('#jobs_bookmark_table').DataTable({
                    responsive: true,
                    pageLength: 10,
                    order: [[0, 'desc']],
                    language: {
                        search: "Search:",
                        searchPlaceholder: "Search jobs...",
                        emptyTable: "No jobs available",
                        zeroRecords: "No matching jobs found",
                        info: "Showing _START_ to _END_ of _TOTAL_ jobs",
                        infoEmpty: "Showing 0 to 0 of 0 jobs",
                        infoFiltered: "(filtered from _MAX_ total jobs)"
                    },
                    columnDefs: [
                        { orderable: false, targets: [0, 6] }, // Disable sorting for Job Title (complex content) and Actions
                        { searchable: false, targets: [6] },   // Disable searching for Actions
                        { 
                            targets: [2, 3], // Contract Type and Contract Time columns
                            render: function(data, type, row) {
                                if (type === 'display') {
                                    return data ? data.charAt(0).toUpperCase() + data.slice(1) : 'N/A';
                                }
                                return data;
                            }
                        }
                    ],
                    drawCallback: function() {
                        // Reinitialize tooltips after table draw
                        $('[data-bs-toggle="tooltip"]').tooltip();
                    }
                });

                setDataTable(dt);
            } catch (error) {
                console.error('Error initializing DataTable:', error);
            }
        }

        // Cleanup function
        return () => {
            if (dataTable) {
                try {
                    dataTable.destroy();
                    setDataTable(null);
                } catch (error) {
                    console.error('Error destroying DataTable:', error);
                }
            }
        };
    }, [loading, jobs]);
    //     const date = new Date(dateString);
    //     return date.toLocaleDateString('en-GB', {
    //         day: '2-digit',
    //         month: '2-digit',
    //         year: 'numeric',
    //     });
    // };

    // const handleSort = () => {
    //     const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
    //     setSortOrder(newSortOrder);
    //     setJobs([...jobs].sort((a, b) => {
    //         const dateA = new Date(a.created_at);
    //         const dateB = new Date(b.created_at);
    //         return newSortOrder === 'asc' ? dateA - dateB : dateB - dateA;
    //     }));
    // };

    // DataTable handles pagination

    return (
        <>
            <div className="wt-admin-right-page-header clearfix">
                <h2>Manage Jobs</h2>
                <div className="breadcrumbs">
                    <a href="/">Home</a>
                    <a href="#">Dashboard</a>
                    <span>My Job Listing</span>
                </div>
            </div>
            <div className="panel panel-default">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0">
                        <i className="fa fa-suitcase" /> Job Details
                    </h4>
                </div>
                <div className="panel-body wt-panel-body p-a20 m-b30">
                    {error && <div className="alert alert-danger">{error}</div>}
                    {loading && <div className="text-center">Loading jobs...</div>}
                    {!loading && (
                        <div className="twm-D_table p-a20 table-responsive">
                            <table id="jobs_bookmark_table" className="table table-bordered twm-bookmark-list-wrap">
                                <thead>
                                    <tr>
                                        <th>Job Title</th>
                                        <th>Category</th>
                                        <th>Contract Type</th>
                                        <th>Contract Time</th>
                                        <th>Source</th>
                                        <th>Company Name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {jobs.length > 0 ? (
                                        jobs.map((job, index) => (
                                            <tr key={job.id || index}>
                                                <td>
                                                    <div className="twm-bookmark-list">
                                                        <div className="twm-media">
                                                            <div style={{width: '75px', height: '75px'}} className="twm-media-pic">
                                                                {job.companyLogo ? (
                                                                    <JobZImage src={job.companyLogo} alt={job.title} />
                                                                ) : (
                                                                    <div className={`company-logo-placeholder ${getColorClass(job.company?.charAt(0))}`}>
                                                                        {job.company?.charAt(0)?.toUpperCase() || ''}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="twm-mid-content">
                                                            <a className="twm-job-title">
                                                                <h4>{job.title}</h4>
                                                                <p className="twm-bookmark-address">
                                                                    <i className="feather-map-pin" />
                                                                    {job.location}
                                                                </p>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>{job.category}</td>
                                                <td>
                                                    <div className="twm-jobs-category">
                                                        <span
                                                            className={`twm-bg-${job.contract_type === 'contract'
                                                                ? 'green'
                                                                : job.contract_type === 'permanent'
                                                                    ? 'golden'
                                                                    : job.contract_type
                                                                        ? 'sky'
                                                                        : 'brown'
                                                                }`}
                                                        >
                                                            {job.contract_type
                                                                ? job.contract_type.charAt(0).toUpperCase() + job.contract_type.slice(1)
                                                                : 'N/A'}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="twm-jobs-category">
                                                        <span
                                                            className={`twm-bg-${job.contract_time
                                                                ? 'sky'
                                                                : 'red'
                                                                }`}
                                                        >
                                                            {job.contract_time
                                                                ? job.contract_time.replace(/[_-]/g, ' ').toUpperCase()
                                                                : 'N/A'}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>
                                                    {job.source || 'N/A'}
                                                </td>
                                                <td>
                                                    <div>{job.company}</div>
                                                </td>
                                                <td>
                                                    <div className="twm-table-controls">
                                                        <ul className="twm-DT-controls-icon list-unstyled">
                                                            <li>
                                                                <a target='_blank' href={job.job_url || '#'} className="twm-job-title">
                                                                    <button
                                                                        title="View profile"
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-placement="top"
                                                                    >
                                                                        <span className="fa fa-eye" />
                                                                    </button>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center">
                                                <p>{t("No jobs found.")}</p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th>Job Title</th>
                                        <th>Category</th>
                                        <th>Contract Type</th>
                                        <th>Contract Time</th>
                                        <th>Source</th>
                                        <th>Company Name</th>
                                        <th>Action</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default EmpManageJobsPage;